import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=e5132dda&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=e5132dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5132dda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5132dda')) {
      api.createRecord('e5132dda', component.options)
    } else {
      api.reload('e5132dda', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=e5132dda&scoped=true&", function () {
      api.rerender('e5132dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Xk3dB1wF8JIt/JS/teamMember.vue"
export default component.exports